import { useState } from "react";
import { Role } from "@bluefalcon/users-management-client-fetch";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    Select,
    FormControl,
    FormLabel,
} from "@chakra-ui/react";

type GrantRoleModalProps = {
    roles: Role[];
    onGrant: (roleId: number) => void;
    isOpen: boolean;
    onClose: () => void;
};

export const GrantRoleModal = ({
    roles,
    onGrant,
    isOpen,
    onClose,
}: GrantRoleModalProps) => {
    const [selectedRole, setSelectedRole] = useState<number | undefined>(undefined);

    const handleGrant = () => {
        if (selectedRole !== undefined) {
            onGrant(selectedRole);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Grant Role</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <FormControl>
                        <FormLabel htmlFor="role">Select Role</FormLabel>
                        <Select
                            id="role"
                            placeholder="Select role"
                            onChange={(e) => setSelectedRole(Number(e.target.value))}
                        >
                            {roles.map((role) => (
                                <option key={role.id} value={role.id}>
                                    {role.name}
                                </option>
                            ))}
                        </Select>
                    </FormControl>
                </ModalBody>
                <ModalFooter>
                    <Button variant="ghost" onClick={onClose} mr={3}>Cancel</Button>
                    <Button colorScheme="primary" onClick={handleGrant}>Grant</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};
